module.exports = __webpack_public_path__ + "static/media/6.0290ca89.jpg";